<section class="banner-outer">

  <div class="loading-blocks" *ngIf = "isloading">
      <div class="timeline-wrapper">
          <div class="timeline-item">
              <div class="animated-background">

                  <div class="background-masker content-top"></div>
                  <div class="background-masker content-second-line"></div>
                  <div class="background-masker content-third-line"></div>
              </div>
          </div>
      </div>
  </div>

	<div *ngIf = "!isloading && banners && banners.length > 0">
		<carousel class="carousel slider-nav banner-slide slide-animated" style = "display: block;" [interval]="carouselInterval">
			<slide *ngFor="let banner of banners" class="slide">

				<img (click)="banner.type == 'sub_project' ? getBannerUrl(banner) : false" class="style1-img-height" [class.pointer] = "banner.type == 'sub_project'" [src]="banner.attributes.banner_image"
					[alt]="banner.attributes.name" width="100%">

			</slide>
		</carousel>
	</div>
</section>
